import './App.css';
import FountainViewer from './FountainViewer';

function App() {
  return (
    <div className="App" style={{ width: '100vw', height: '100vh' }}>
      <FountainViewer />
    </div>
  );
}

export default App;